import React from "react";
import { TouchableOpacity, View, StyleSheet } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import SvgImage from "./choose-avatar-components/SvgImage";
import { AppImages } from "../utility/AppImages";

interface StreamActionIconProps {
  onPress?: () => void;
  type: "share" | "gift" | "chat" | "like" | "send";
}

export const StreamActionIcon: React.FC<StreamActionIconProps> = ({
  onPress,
  type,
}) => {
  const isSendIcon = type === "send";

  const getIconSource = () => {
    switch (type) {
      case "share":
        return AppImages.Ko_Share;
      case "gift":
        return AppImages.Ko_Gift;
      case "chat":
        return AppImages.Ko_Chat;
      case "like":
        return AppImages.Ko_Like;
      case "send":
        return AppImages.Ko_send;
      default:
        return AppImages.Ko_Share;
    }
  };

  if (isSendIcon) {
    return (
      <TouchableOpacity onPress={onPress}>
        <View style={[styles.container, styles.sendContainer]}>
          <SvgImage src={getIconSource()} variant="streamActionIcon" />
        </View>
      </TouchableOpacity>
    );
  }

  return (
    <TouchableOpacity onPress={onPress}>
      <LinearGradient
        colors={["#1F2937", "#111827"]}
        start={[0, 0]}
        end={[1, 1]}
        style={[styles.container, styles.defaultContainer]}
      >
        <SvgImage src={getIconSource()} variant="streamActionIcon" />
      </LinearGradient>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    display: "flex",
    width: 40,
    height: 40,
    padding: 6,
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
    aspectRatio: 1 / 1,
    borderRadius: 8,
  },
  defaultContainer: {
    borderWidth: 0.8,
    borderColor: "#374151",
  },
  sendContainer: {
    backgroundColor: "#DC2626",
  },
});

export default StreamActionIcon;
